import { isMaintenanceJsonResponse } from './maintenancePolling.js';

const MAINTENANCE_HTTP_STATUS = 503;

/**
 * During product updates (maintenance mode) CSRF refresh returns a maintenance payload (or 503),
 * not a real session expiry — suppress the toast so editors are not told to re-login and copy text.
 *
 * @param {{
 *   maintenanceActive?: boolean,
 *   responseStatus?: number|null,
 *   responseData?: unknown,
 * }} [input]
 * @returns {boolean}
 */
export function shouldSuppressSessionExpiredNotification({
	maintenanceActive = false,
	responseStatus = null,
	responseData = null,
} = {}) {
	if (maintenanceActive) {
		return true;
	}

	if (responseStatus === MAINTENANCE_HTTP_STATUS) {
		return true;
	}

	return isMaintenanceJsonResponse(responseData);
}
